{
  "INTEGRATION_SETTINGS": {
    "SHOPIFY": {
      "DELETE": {
        "TITLE": "Delete Shopify Integration",
        "MESSAGE": "Are you sure you want to delete the Shopify integration?"
      },
      "STORE_URL": {
        "TITLE": "Connect Shopify Store",
        "LABEL": "Store URL",
        "PLACEHOLDER": "your-store.myshopify.com",
        "HELP": "Enter your Shopify store's myshopify.com URL",
        "CANCEL": "إلغاء",
        "SUBMIT": "Connect Store"
      },
      "ERROR": "There was an error connecting to Shopify. Please try again or contact support if the issue persists."
    },
    "HEADER": "خيارات الربط",
    "DESCRIPTION": "يتكامل مركز الاتصال مع أدوات وخدمات متعددة لتحسين كفاءة فريقك. استكشف القائمة أدناه لتكوين تطبيقاتك المفضلة.",
    "LEARN_MORE": "معرفة المزيد عن التكاملات",
    "LOADING": "جاري جلب التكاملات",
    "CAPTAIN": {
      "DISABLED": "لم يتم تمكين الكابتن على حسابك.",
      "CLICK_HERE_TO_CONFIGURE": "انقر هنا للتهيئة",
      "LOADING_CONSOLE": "جار جلب وحدة التحكم بالكابتن...",
      "FAILED_TO_LOAD_CONSOLE": "فشل أثناء جلب وحدة تحكم الكابتن. الرجاء التحديث والمحاولة مرة أخرى."
    },
    "WEBHOOK": {
      "SUBSCRIBED_EVENTS": "الأحداث المشتركة",
      "LEARN_MORE": "Learn more about webhooks",
      "FORM": {
        "CANCEL": "إلغاء",
        "DESC": "أحداث Webhook توفر لك معلومات في الوقت الحقيقي حول ما يحدث في حسابك. الرجاء إدخال عنوان URL صالح لتكوين callback.",
        "SUBSCRIPTIONS": {
          "LABEL": "الأحداث",
          "EVENTS": {
            "INBOX_CREATED": "تم إنشاء صندوق الوارد",
            "CONVERSATION_CREATED": "تم إنشاء المحادثة",
            "CONVERSATION_STATUS_CHANGED": "تم تغيير حالة المحادثة",
            "CONVERSATION_UPDATED": "تم تحديث المحادثة",
            "MESSAGE_CREATED": "تم إنشاء رسالة",
            "MESSAGE_UPDATED": "تم تحديث الرسالة",
            "WEBWIDGET_TRIGGERED": "أداة الدردشة المباشرة مفتوحة من قبل المستخدم",
            "CONTACT_CREATED": "Contact created",
            "CONTACT_UPDATED": "Contact updated",
            "JARABOT_EVENT": "Internal events"
          }
        },
        "END_POINT": {
          "LABEL": "رابط Webhook",
          "PLACEHOLDER": "Example: {webhookExampleURL}",
          "ERROR": "الرجاء إدخال عنوان URL صالح"
        },
        "EDIT_SUBMIT": "تحديث الويبهوك",
        "ADD_SUBMIT": "إنشاء webhook"
      },
      "TITLE": "Webhook",
      "CONFIGURE": "تهيئة",
      "HEADER": "إعدادات الـ Webhook",
      "HEADER_BTN_TXT": "إضافة webhook جديد",
      "LOADING": "جار جلب الـ Webhooks",
      "SEARCH_404": "لا توجد عناصر مطابقة لهذا الاستعلام",
      "SIDEBAR_TXT": "<p><b>Webhooks</b> </p> <p>Webhooks هي إعادات HTTP callbacks التي يمكن تعريفها لكل حساب. يتم تشغيلها بأحداث مثل إنشاء الرسائل. يمكنك إنشاء أكثر من Webhook واحد لهذا الحساب. <br /><br /> لإنشاء <b>webhook</b>، انقر فوق <b>إضافة Webhooks جديد</b>. يمكنك أيضا إزالة أي رابط ويب موجود بالنقر على زر الحذف.</p>",
      "LIST": {
        "404": "لا توجد webhooks مكونة لهذا الحساب.",
        "TITLE": "إدارة الـ webhooks",
        "TABLE_HEADER": {
          "WEBHOOK_ENDPOINT": "Webhook endpoint",
          "ACTIONS": "الإجراءات"
        }
      },
      "EDIT": {
        "BUTTON_TEXT": "تعديل",
        "TITLE": "تعديل webhook",
        "API": {
          "SUCCESS_MESSAGE": "تم تحديث تكوين ويبهوك بنجاح",
          "ERROR_MESSAGE": "تعذر الاتصال بالخادم، الرجاء المحاولة مرة أخرى لاحقاً"
        }
      },
      "ADD": {
        "CANCEL": "إلغاء",
        "TITLE": "إضافة webhook جديد",
        "API": {
          "SUCCESS_MESSAGE": "تم إضافة إعدادات Webhook بنجاح",
          "ERROR_MESSAGE": "تعذر الاتصال بالخادم، الرجاء المحاولة مرة أخرى لاحقاً"
        }
      },
      "DELETE": {
        "BUTTON_TEXT": "حذف",
        "API": {
          "SUCCESS_MESSAGE": "تم حذف Webhook بنجاح",
          "ERROR_MESSAGE": "تعذر الاتصال بالخادم، الرجاء المحاولة مرة أخرى لاحقاً"
        },
        "CONFIRM": {
          "TITLE": "تأكيد الحذف",
          "MESSAGE": "هل أنت متأكد من حذف webhook؟ ({webhookURL})",
          "YES": "نعم، احذف ",
          "NO": "لا، احتفظ به"
        }
      },
      "DISABLED_BADGE": "معطّل",
      "DISABLED_REASON": "تم التعطيل تلقائياً بعد {count} إخفاقات متتالية. آخر خطأ: {error}",
      "ENABLE": {
        "BUTTON_TEXT": "تفعيل",
        "API": {
          "SUCCESS_MESSAGE": "تم تفعيل Webhook بنجاح",
          "ERROR_MESSAGE": "تعذر تفعيل Webhook، يرجى المحاولة مرة أخرى لاحقاً"
        }
      }
    },
    "SLACK": {
      "DELETE": "حذف",
      "DELETE_CONFIRMATION": {
        "TITLE": "Delete the integration",
        "MESSAGE": "Are you sure you want to delete the integration? Doing so will result in the loss of access to conversations on your Slack workspace."
      },
      "HELP_TEXT": {
        "TITLE": "استخدام تكامل Slack",
        "BODY": "مع هذا التكامل، ستتم مزامنة جميع محادثاتك الواردة مع القناة ***{selectedChannelName}*** في مساحة عمل Slack الخاصة بك. يمكنك إدارة جميع محادثات عملائك مباشرة داخل القناة دون أن تفوتك أي رسالة.\n\nفيما يلي الميزات الرئيسية لهذا التكامل:\n\n**الرد على المحادثات من داخل Slack:** للرد على محادثة في قناة Slack ***{selectedChannelName}***، اكتب رسالتك وأرسلها كسلسلة رسائل (thread). سيؤدي ذلك إلى إرسال رد إلى العميل عبر مركز الاتصال. الأمر بهذه البساطة!\n\n **إنشاء ملاحظات خاصة:** إذا كنت تريد إنشاء ملاحظات خاصة بدلاً من الردود، فابدأ رسالتك بـ ***`note:`***. يضمن ذلك بقاء رسالتك خاصة وعدم ظهورها للعميل.\n\n**ربط ملف تعريف الوكيل:** إذا كان لدى الشخص الذي رد على Slack ملف تعريف وكيل في مركز الاتصال بنفس البريد الإلكتروني، فسيتم ربط الردود بملف تعريف الوكيل هذا تلقائيًا. هذا يعني أنه يمكنك بسهولة تتبع من قال ماذا ومتى. من ناحية أخرى، إذا لم يكن لدى صاحب الرد ملف تعريف وكيل مرتبط، فستظهر الردود للعميل من ملف تعريف الروبوت.",
        "SELECTED": "selected"
      },
      "SELECT_CHANNEL": {
        "OPTION_LABEL": "Select a channel",
        "UPDATE": "تحديث",
        "BUTTON_TEXT": "Connect channel",
        "DESCRIPTION": "مساحة عمل Slack الخاصة بك مرتبطة الآن بمركز الاتصال. ومع ذلك، فإن التكامل غير نشط حاليًا. لتفعيل التكامل وربط قناة، يرجى النقر على الزر أدناه.\n\n**ملاحظة:** إذا كنت تحاول ربط قناة خاصة، فأضف تطبيقنا إلى قناة Slack قبل متابعة هذه الخطوة.",
        "ATTENTION_REQUIRED": "Attention required",
        "EXPIRED": "Your Slack integration has expired. To continue receiving messages on Slack, please delete the integration and connect your workspace again."
      },
      "UPDATE_ERROR": "There was an error updating the integration, please try again",
      "UPDATE_SUCCESS": "The channel is connected successfully",
      "FAILED_TO_FETCH_CHANNELS": "There was an error fetching the channels from Slack, please try again"
    },
    "OPEN_AI": {
      "AI_ASSIST": "مساعدة AI",
      "WITH_AI": " {option} باستخدام AI ",
      "OPTIONS": {
        "REPLY_SUGGESTION": "اقتراح الرد",
        "SUMMARIZE": "تلخيص",
        "REPHRASE": "تحسين الكتابة",
        "FIX_SPELLING_GRAMMAR": "تصحيح الإملاء والقواعد",
        "SHORTEN": "اختصار",
        "EXPAND": "توسيع",
        "MAKE_FRIENDLY": "تغيير نبرة الرسالة لتكون ودية",
        "MAKE_FORMAL": "استخدام نبرة رسمية",
        "SIMPLIFY": "تبسيط",
        "TRANSLATE": "ترجمة",
        "TRANSLATE_TO_MAJORITY_LANGUAGE": "الترجمة إلى لغة الأغلبية"
      },
      "ASSISTANCE_MODAL": {
        "DRAFT_TITLE": "محتوى المسودة",
        "GENERATED_TITLE": "المحتوى المُنشأ",
        "AI_WRITING": "AI يكتب الآن",
        "BUTTONS": {
          "APPLY": "استخدام هذا الاقتراح",
          "CANCEL": "إلغاء"
        }
      },
      "CTA_MODAL": {
        "TITLE": "التكامل مع OpenAI",
        "DESC": "أضف ميزات AI متقدمة إلى لوحة التحكم الخاصة بك باستخدام نماذج GPT من OpenAI. للبدء، أدخل مفتاح API من حساب OpenAI الخاص بك.",
        "KEY_PLACEHOLDER": "أدخل مفتاح API الخاص بـ OpenAI",
        "BUTTONS": {
          "NEED_HELP": "تحتاج مساعدة؟",
          "DISMISS": "تجاهل",
          "FINISH": "إنهاء الإعداد"
        },
        "DISMISS_MESSAGE": "يمكنك إعداد التكامل مع OpenAI لاحقًا في أي وقت تريده.",
        "SUCCESS_MESSAGE": "تم إعداد التكامل مع OpenAI بنجاح"
      },
      "TITLE": "التحسين باستخدام AI",
      "SUMMARY_TITLE": "التلخيص باستخدام AI",
      "REPLY_TITLE": "اقتراح الرد باستخدام AI",
      "SUBTITLE": "سيتم إنشاء رد محسّن باستخدام AI بناءً على مسودتك الحالية.",
      "TONE": {
        "TITLE": "نبرة",
        "OPTIONS": {
          "PROFESSIONAL": "احترافية",
          "FRIENDLY": "ودية"
        }
      },
      "BUTTONS": {
        "GENERATE": "إنشاء",
        "GENERATING": "جارٍ الإنشاء...",
        "CANCEL": "إلغاء"
      },
      "GENERATE_ERROR": "There was an error processing the content, please try again"
    },
    "DELETE": {
      "BUTTON_TEXT": "حذف",
      "API": {
        "SUCCESS_MESSAGE": "تم حذف التكامل بنجاح"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "ربط الاتصال"
    },
    "DASHBOARD_APPS": {
      "TITLE": "تطبيقات لوحة التحكم",
      "HEADER_BTN_TXT": "إضافة تطبيق جديد للوحة التحكم",
      "SIDEBAR_TXT": "<p><b>تطبيقات لوحة التحكم</b></p><p>تتيح تطبيقات لوحة التحكم للمؤسسات تضمين تطبيق داخل لوحة التحكم لتوفير السياق لوكلاء دعم العملاء. تتيح لك هذه الميزة إنشاء تطبيق بشكل مستقل وتضمينه داخل لوحة التحكم لعرض معلومات المستخدم أو طلباته أو سجل مدفوعاته السابقة.</p><p>عند تضمين تطبيقك في لوحة التحكم، سيحصل تطبيقك على سياق المحادثة وجهة الاتصال كحدث نافذة (window event). قم بتنفيذ مستمع لحدث الرسالة (message) في صفحتك لاستلام السياق.</p><p>لإضافة تطبيق جديد إلى لوحة التحكم، انقر على الزر 'إضافة تطبيق جديد للوحة التحكم'.</p>",
      "DESCRIPTION": "تسمح تطبيقات لوحة التحكم للمنظمات بتضمين تطبيق داخل لوحة التحكم لتوفير السياق لوكلاء دعم العملاء. هذه الميزة تسمح لك بإنشاء تطبيق بشكل مستقل وإدراج لتوفير معلومات المستخدم أو طلباتهم أو سجل الدفع السابق.",
      "LEARN_MORE": "معرفة المزيد حول تطبيقات لوحة التحكم",
      "LIST": {
        "404": "لا توجد تطبيقات لوحة التحكم التي تم تكوينها على هذا الحساب حتى الآن",
        "LOADING": "جلب تطبيقات لوحة التحكم...",
        "TABLE_HEADER": {
          "NAME": "الاسم",
          "ENDPOINT": "نقطة الوصول"
        },
        "EDIT_TOOLTIP": "تعديل التطبيق",
        "DELETE_TOOLTIP": "حذف التطبيق"
      },
      "FORM": {
        "TITLE_LABEL": "الاسم",
        "TITLE_PLACEHOLDER": "أدخل اسم لتطبيق لوحة التحكم الخاصة بك",
        "TITLE_ERROR": "مطلوب اسم لتطبيق لوحة التحكم",
        "URL_LABEL": "نقطة الوصول",
        "URL_PLACEHOLDER": "أدخل عنوان URL لنقطة النهاية حيث يتم استضافة التطبيق الخاص بك",
        "URL_ERROR": "رابط صحيح مطلوب"
      },
      "CREATE": {
        "HEADER": "إضافة تطبيق جديد للوحة التحكم",
        "FORM_SUBMIT": "إرسال",
        "FORM_CANCEL": "إلغاء",
        "API_SUCCESS": "تم تكوين تطبيق لوحة التحكم بنجاح",
        "API_ERROR": "لم نتمكن من إنشاء تطبيق. الرجاء المحاولة مرة أخرى لاحقاً"
      },
      "UPDATE": {
        "HEADER": "تعديل تطبيق لوحة التحكم",
        "FORM_SUBMIT": "تحديث",
        "FORM_CANCEL": "إلغاء",
        "API_SUCCESS": "تم تحديث تطبيق لوحة التحكم بنجاح",
        "API_ERROR": "لم نتمكن من تحديث التطبيق. الرجاء المحاولة مرة أخرى لاحقاً"
      },
      "DELETE": {
        "CONFIRM_YES": "نعم، احذف",
        "CONFIRM_NO": "لا، احتفظ به",
        "TITLE": "تأكيد الحذف",
        "MESSAGE": "هل أنت متأكد من حذف التطبيق - {appName}؟",
        "API_SUCCESS": "تم حذف تطبيق لوحة التحكم بنجاح",
        "API_ERROR": "لم نتمكن من حذف التطبيق. الرجاء المحاولة مرة أخرى لاحقاً"
      }
    },
    "LINEAR": {
      "ADD_OR_LINK_BUTTON": "Create/Link Linear Issue",
      "LOADING": "جلب مشاكل من Linear...",
      "LOADING_ERROR": "حدث خطأ أثناء جلب المشكلات من Linear، الرجاء المحاولة مرة أخرى",
      "CREATE": "إنشاء",
      "LINK": {
        "SEARCH": "البحث عن المشكلات",
        "SELECT": "اختر مشكلة",
        "TITLE": "الرابط",
        "EMPTY_LIST": "لم يتم العثور على مشاكل في Linear",
        "LOADING": "جار التحميل",
        "ERROR": "حدث خطأ أثناء جلب المشكلات من Linear، الرجاء المحاولة مرة أخرى",
        "LINK_SUCCESS": "تم ربط المشكلة بنجاح",
        "LINK_ERROR": "حدث خطأ أثناء ربط المشكلة، الرجاء المحاولة مرة أخرى",
        "LINK_TITLE": "Conversation (#{conversationId}) with {name}"
      },
      "ADD_OR_LINK": {
        "TITLE": "إنشاء/رابط مشكلة في Linear",
        "DESCRIPTION": "إنشاء مشكلات في Linear من المحادثات، أو ربط المشكلات الموجودة لتعقب سلس.",
        "FORM": {
          "TITLE": {
            "LABEL": "العنوان",
            "PLACEHOLDER": "أدخل العنوان",
            "REQUIRED_ERROR": "العنوان مطلوب"
          },
          "DESCRIPTION": {
            "LABEL": "الوصف",
            "PLACEHOLDER": "أدخل الوصف"
          },
          "TEAM": {
            "LABEL": "الفريق",
            "PLACEHOLDER": "اختر فريق",
            "SEARCH": "البحث عن فريق",
            "REQUIRED_ERROR": "الفريق مطلوب"
          },
          "ASSIGNEE": {
            "LABEL": "المكلَّف",
            "PLACEHOLDER": "اختر المحال إليه",
            "SEARCH": "البحث عن المحال إليه"
          },
          "PRIORITY": {
            "LABEL": "الأولوية",
            "PLACEHOLDER": "تحديد الأولوية",
            "SEARCH": "أولوية البحث"
          },
          "LABEL": {
            "LABEL": "الوسم",
            "PLACEHOLDER": "حدد التسمية",
            "SEARCH": "ابحث عن تصنيفات"
          },
          "STATUS": {
            "LABEL": "الحالة",
            "PLACEHOLDER": "اختر الحالة",
            "SEARCH": "حالة البحث"
          },
          "PROJECT": {
            "LABEL": "المشروع",
            "PLACEHOLDER": "حدد المشروع",
            "SEARCH": "البحث عن المشروع"
          }
        },
        "CREATE": "إنشاء",
        "CANCEL": "إلغاء",
        "CREATE_SUCCESS": "تم إنشاء المشكلة بنجاح",
        "CREATE_ERROR": "حدث خطأ أثناء إنشاء المشكلة، يرجى المحاولة مرة أخرى",
        "LOADING_TEAM_ERROR": "حدث خطأ أثناء جلب الفرق, الرجاء المحاولة مرة أخرى",
        "LOADING_TEAM_ENTITIES_ERROR": "حدث خطأ أثناء جلب كيانات الفريق، يرجى المحاولة مرة أخرى"
      },
      "ISSUE": {
        "STATUS": "الحالة",
        "PRIORITY": "الأولوية",
        "ASSIGNEE": "المكلَّف",
        "LABELS": "الوسوم",
        "CREATED_AT": "Created at {createdAt}"
      },
      "UNLINK": {
        "TITLE": "إلغاء الربط",
        "SUCCESS": "تم إلغاء ربط المشكلة بنجاح",
        "ERROR": "حدث خطأ أثناء إلغاء ربط المشكلة، الرجاء المحاولة مرة أخرى"
      },
      "DELETE": {
        "TITLE": "Are you sure you want to delete the integration?",
        "MESSAGE": "Are you sure you want to delete the integration?",
        "CONFIRM": "نعم، احذف",
        "CANCEL": "إلغاء"
      }
    }
  },
  "CAPTAIN": {
    "NAME": "قائد",
    "HEADER_KNOW_MORE": "Know more",
    "COPILOT": {
      "SEND_MESSAGE": "إرسال الرسالة...",
      "EMPTY_MESSAGE": "حدث خطأ أثناء توليد الرد. يرجى المحاولة مرة أخرى.",
      "LOADER": "Captain is thinking",
      "YOU": "أنت",
      "USE": "Use this",
      "RESET": "Reset",
      "SELECT_ASSISTANT": "Select Assistant"
    },
    "PAYWALL": {
      "TITLE": "Upgrade to use Captain AI",
      "AVAILABLE_ON": "Captain is not available on the free plan.",
      "UPGRADE_PROMPT": "Upgrade your plan to get access to our assistants, copilot and more.",
      "UPGRADE_NOW": "Upgrade now",
      "CANCEL_ANYTIME": "You can change or cancel your plan anytime"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "Captain AI feature is only available in a paid plan.",
      "UPGRADE_PROMPT": "Upgrade your plan to get access to our assistants, copilot and more.",
      "ASK_ADMIN": "Please reach out to your administrator for the upgrade."
    },
    "BANNER": {
      "RESPONSES": "You've used over 80% of your response limit. To continue using Captain AI, please upgrade.",
      "DOCUMENTS": "Document limit reached. Upgrade to continue using Captain AI."
    },
    "FORM": {
      "CANCEL": "إلغاء",
      "CREATE": "إنشاء",
      "EDIT": "تحديث"
    },
    "ASSISTANTS": {
      "HEADER": "Assistants",
      "ADD_NEW": "Create a new assistant",
      "DELETE": {
        "TITLE": "Are you sure to delete the assistant?",
        "DESCRIPTION": "This action is permanent. Deleting this assistant will remove it from all connected inboxes and permanently erase all generated knowledge.",
        "CONFIRM": "نعم، احذف",
        "SUCCESS_MESSAGE": "The assistant has been successfully deleted",
        "ERROR_MESSAGE": "There was an error deleting the assistant, please try again."
      },
      "FORM_DESCRIPTION": "Fill out the details below to name your assistant, describe its purpose, and specify the product it will support.",
      "CREATE": {
        "TITLE": "Create an assistant",
        "SUCCESS_MESSAGE": "The assistant has been successfully created",
        "ERROR_MESSAGE": "There was an error creating the assistant, please try again."
      },
      "FORM": {
        "NAME": {
          "LABEL": "Assistant Name",
          "PLACEHOLDER": "Enter a name for the assistant",
          "ERROR": "Please provide a name for the assistant"
        },
        "DESCRIPTION": {
          "LABEL": "Assistant Description",
          "PLACEHOLDER": "Describe how and where this assistant will be used",
          "ERROR": "A description is required"
        },
        "PRODUCT_NAME": {
          "LABEL": "Product Name",
          "PLACEHOLDER": "Enter the name of the product this assistant is designed for",
          "ERROR": "The product name is required"
        },
        "FEATURES": {
          "TITLE": "الخصائص",
          "ALLOW_CONVERSATION_FAQS": "Generate FAQs from resolved conversations",
          "ALLOW_MEMORIES": "Capture key details as memories from customer interactions."
        }
      },
      "EDIT": {
        "TITLE": "Update the assistant",
        "SUCCESS_MESSAGE": "The assistant has been successfully updated",
        "ERROR_MESSAGE": "There was an error updating the assistant, please try again."
      },
      "OPTIONS": {
        "EDIT_ASSISTANT": "Edit Assistant",
        "DELETE_ASSISTANT": "Delete Assistant",
        "VIEW_CONNECTED_INBOXES": "View connected inboxes"
      },
      "EMPTY_STATE": {
        "TITLE": "No assistants available",
        "SUBTITLE": "Create an assistant to provide quick and accurate responses to your users. It can learn from your help articles and past conversations.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Assistant",
          "NOTE": "Captain Assistant engages directly with customers, learns from your help docs and past conversations, and delivers instant, accurate responses. It handles the initial queries, providing quick resolutions before  transferring to an agent when needed."
        }
      }
    },
    "DOCUMENTS": {
      "HEADER": "Documents",
      "ADD_NEW": "Create a new document",
      "RELATED_RESPONSES": {
        "TITLE": "Related FAQs",
        "DESCRIPTION": "These FAQs are generated directly from the document."
      },
      "FORM_DESCRIPTION": "Enter the URL of the document to add it as a knowledge source and choose the assistant to associate it with.",
      "CREATE": {
        "TITLE": "Add a document",
        "SUCCESS_MESSAGE": "The document has been successfully created",
        "ERROR_MESSAGE": "There was an error creating the document, please try again."
      },
      "FORM": {
        "URL": {
          "LABEL": "الرابط",
          "PLACEHOLDER": "Enter the URL of the document",
          "ERROR": "Please provide a valid URL for the document"
        },
        "ASSISTANT": {
          "LABEL": "Assistant",
          "PLACEHOLDER": "Select the assistant",
          "ERROR": "The assistant field is required"
        }
      },
      "DELETE": {
        "TITLE": "Are you sure to delete the document?",
        "DESCRIPTION": "This action is permanent. Deleting this document will permanently erase all generated knowledge.",
        "CONFIRM": "نعم، احذف",
        "SUCCESS_MESSAGE": "The document has been successfully deleted",
        "ERROR_MESSAGE": "There was an error deleting the document, please try again."
      },
      "OPTIONS": {
        "VIEW_RELATED_RESPONSES": "View Related Responses",
        "DELETE_DOCUMENT": "Delete Document"
      },
      "EMPTY_STATE": {
        "TITLE": "No documents available",
        "SUBTITLE": "Documents are used by your assistant to generate FAQs. You can import documents to provide context for your assistant.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Document",
          "NOTE": "A document in Captain serves as a knowledge resource for the assistant. By connecting your help center or guides, Captain can analyze the content and provide accurate responses for customer inquiries."
        }
      }
    },
    "RESPONSES": {
      "HEADER": "FAQs",
      "ADD_NEW": "Create new FAQ",
      "DOCUMENTABLE": {
        "CONVERSATION": "Conversation #{id}"
      },
      "SELECTED": "{count} selected",
      "BULK_APPROVE_BUTTON": "Approve",
      "BULK_DELETE_BUTTON": "حذف",
      "BULK_APPROVE": {
        "SUCCESS_MESSAGE": "FAQs approved successfully",
        "ERROR_MESSAGE": "There was an error approving the FAQs, please try again."
      },
      "BULK_DELETE": {
        "TITLE": "Delete FAQs?",
        "DESCRIPTION": "Are you sure you want to delete the selected FAQs? This action cannot be undone.",
        "CONFIRM": "Yes, delete all",
        "SUCCESS_MESSAGE": "FAQs deleted successfully",
        "ERROR_MESSAGE": "There was an error deleting the FAQs, please try again."
      },
      "DELETE": {
        "TITLE": "Are you sure to delete the FAQ?",
        "DESCRIPTION": "",
        "CONFIRM": "نعم، احذف",
        "SUCCESS_MESSAGE": "FAQ deleted successfully",
        "ERROR_MESSAGE": "There was an error deleting the FAQ, please try again."
      },
      "FILTER": {
        "ASSISTANT": "Assistant: {selected}",
        "STATUS": "Status: {selected}",
        "ALL_ASSISTANTS": "الكل"
      },
      "STATUS": {
        "TITLE": "الحالة",
        "PENDING": "معلق",
        "APPROVED": "Approved",
        "ALL": "الكل"
      },
      "FORM_DESCRIPTION": "Add a question and its corresponding answer to the knowledge base and select the assistant it should be associated with.",
      "CREATE": {
        "TITLE": "Add an FAQ",
        "SUCCESS_MESSAGE": "The response has been added successfully.",
        "ERROR_MESSAGE": "An error occurred while adding the response. Please try again."
      },
      "FORM": {
        "QUESTION": {
          "LABEL": "Question",
          "PLACEHOLDER": "Enter the question here",
          "ERROR": "Please provide a valid question."
        },
        "ANSWER": {
          "LABEL": "Answer",
          "PLACEHOLDER": "Enter the answer here",
          "ERROR": "Please provide a valid answer."
        },
        "ASSISTANT": {
          "LABEL": "Assistant",
          "PLACEHOLDER": "Select an assistant",
          "ERROR": "Please select an assistant."
        }
      },
      "EDIT": {
        "TITLE": "Update the FAQ",
        "SUCCESS_MESSAGE": "The FAQ has been successfully updated",
        "ERROR_MESSAGE": "There was an error updating the FAQ, please try again",
        "APPROVE_SUCCESS_MESSAGE": "The FAQ was marked as approved"
      },
      "OPTIONS": {
        "APPROVE": "Mark as approved",
        "EDIT_RESPONSE": "Edit FAQ",
        "DELETE_RESPONSE": "Delete FAQ"
      },
      "EMPTY_STATE": {
        "TITLE": "No FAQs Found",
        "SUBTITLE": "FAQs help your assistant provide quick and accurate answers to questions from your customers. They can be generated automatically from your content or can be added manually.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain FAQ",
          "NOTE": "Captain FAQs detects common customer questions—whether missing from your knowledge base or frequently asked—and generates relevant FAQs to improve support. You can review each suggestion and decide whether to approve or reject it."
        }
      }
    },
    "INBOXES": {
      "HEADER": "Connected Inboxes",
      "ADD_NEW": "Connect a new inbox",
      "OPTIONS": {
        "DISCONNECT": "قطع الاتصال"
      },
      "DELETE": {
        "TITLE": "Are you sure to disconnect the inbox?",
        "DESCRIPTION": "",
        "CONFIRM": "نعم، احذف",
        "SUCCESS_MESSAGE": "The inbox was successfully disconnected.",
        "ERROR_MESSAGE": "There was an error disconnecting the inbox, please try again."
      },
      "FORM_DESCRIPTION": "Choose an inbox to connect with the assistant.",
      "CREATE": {
        "TITLE": "Connect an Inbox",
        "SUCCESS_MESSAGE": "The inbox was successfully connected.",
        "ERROR_MESSAGE": "An error occurred while connecting the inbox. Please try again."
      },
      "FORM": {
        "INBOX": {
          "LABEL": "صندوق الوارد",
          "PLACEHOLDER": "Choose the inbox to deploy the assistant.",
          "ERROR": "An inbox selection is required."
        }
      },
      "EMPTY_STATE": {
        "TITLE": "No Connected Inboxes",
        "SUBTITLE": "Connecting an inbox allows the assistant to handle initial questions from your customers before transferring them to you."
      }
    }
  }
}
